"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CommandRequestUserPasswordReset model module.
 * @module model/CommandRequestUserPasswordReset
 * @version 1.1.3-alpha.1
 */
class CommandRequestUserPasswordReset {
  /**
   * Constructs a new <code>CommandRequestUserPasswordReset</code>.
   * @alias module:model/CommandRequestUserPasswordReset
   * @param email {String} 
   */
  constructor(email) {
    CommandRequestUserPasswordReset.initialize(this, email);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, email) {
    obj['email'] = email;
  }

  /**
   * Constructs a <code>CommandRequestUserPasswordReset</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CommandRequestUserPasswordReset} obj Optional instance to populate.
   * @return {module:model/CommandRequestUserPasswordReset} The populated <code>CommandRequestUserPasswordReset</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CommandRequestUserPasswordReset();
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CommandRequestUserPasswordReset</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommandRequestUserPasswordReset</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CommandRequestUserPasswordReset.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    return true;
  }
}
CommandRequestUserPasswordReset.RequiredProperties = ["email"];

/**
 * @member {String} email
 */
CommandRequestUserPasswordReset.prototype['email'] = undefined;
var _default = exports.default = CommandRequestUserPasswordReset;